import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useEventListener } from 'ahooks'
import * as React from 'react'
import { ReactNode, useCallback, useEffect } from 'react'

export interface ConfirmationProps {
  open: boolean
  setOpen: (open: boolean) => any

  title?: string | ReactNode
  content?: ReactNode

  actions: ReactNode
  maxWidth?: number

  onConfirm?: () => void
}

export const Confirmation = ({
  open,
  setOpen,
  title,
  content,
  actions,
  maxWidth = 312,
  onConfirm
}: ConfirmationProps) => {
  const handleKeydown = useCallback((e: KeyboardEvent) => {
    if(e.key === 'Enter') {
      onConfirm?.()
    }
  }, [onConfirm])

  useEffect(() => {
    if(open) {
      window.addEventListener('keydown', handleKeydown)
    } else {
      window.removeEventListener('keydown', handleKeydown)
    }

    return () => window.removeEventListener('keydown', handleKeydown)
  }, [open])

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth='xs'
      sx={{ borderRadius: 0 }}
    >
      <DialogTitle>
        {title}
      </DialogTitle>
      <DialogContent style={{ maxWidth }}>
        {content}
      </DialogContent>
      <DialogActions>
        {actions}
      </DialogActions>
    </Dialog>
  )
}
